import { EMIT_SOUND, SET_MUTE } from '~/redux/reducers/sound';

export const TAB_PUSH = 'tab_push';
export const POP_WINDOW = 'pop_window';
export const ESCAPE = 'escape';
export const SHRED = 'shred';
export const OPEN_DETAIL_VIEW = 'open_detail_view';
export const OPEN_PURCHASE = 'open_purchase';
export const MONEY_SHOT = 'money_shot';
export const RADAR_OPENED = 'radar_opened';
export const RADAR_CARD_FLIPPED = 'card_flipped';
export const RADAR_SUPER_LIKE = 'superlike';
export const RADAR_SWIPE = 'swipe';

export function setMute() {
  return {
    type: SET_MUTE,
  };
}

export function emitSound(soundName) {
  return {
    type: EMIT_SOUND,
    name: soundName,
  };
}

export default {
  setMute,
  emitSound,
};
